import Image from 'next/image';

// Оптимизатор /_next/image выключен (images.loader: 'custom'): внешние картинки он качал
// на сервер через node-fetch с распаковкой Brotli (Node2Shell, CVE-2026-111497).
const AppImage = (props) => <Image {...props} unoptimized />;

export default AppImage;
